import clickCollectReducer from './clickCollect.reducer';
export default clickCollectReducer;

export * from './clickCollect.selectors';
